import * as ValidateModel from '../../shared/ValidateModel';

class Garment {
    readonly idGarment: number;

    readonly idProduct: number;

    readonly name: string;

    readonly descriptionShort: string;

    readonly description: string;

    readonly link: string;

    readonly image: string;

    readonly price: string;

    readonly priceTaxExcl: string;

    readonly priceLow: string;

    readonly priceLowPercentage: string;

    readonly priceLowAmount: string;

    readonly garmentPartCount: number;

    readonly sameGarmentPartCount: number;

    constructor(
        idGarment: number,
        idProduct: number,
        name: string,
        descriptionShort: string,
        description: string,
        link: string,
        image: string,
        price: string,
        priceTaxExcl: string,
        priceLow: string,
        priceLowPercentage: string,
        priceLowAmount: string,
        garmentPartCount: number,
        sameGarmentPartCount: number,
    ) {
        ValidateModel.isNumber(idGarment, 'idGarment');
        ValidateModel.isNumber(idProduct, 'idProduct');
        ValidateModel.isString(name, 'name');
        ValidateModel.isString(descriptionShort, 'descriptionShort');
        ValidateModel.isString(description, 'description');
        ValidateModel.isString(link, 'link');
        ValidateModel.isString(image, 'image');
        ValidateModel.isString(price, 'price');
        ValidateModel.isString(priceTaxExcl, 'priceTaxExcl');
        ValidateModel.isString(priceLow, 'priceLow');
        ValidateModel.isString(priceLowPercentage, 'priceLowPercentage');
        ValidateModel.isString(priceLowAmount, 'priceLowAmount');
        ValidateModel.isNumber(garmentPartCount, 'garmentPartCount');
        ValidateModel.isNumber(sameGarmentPartCount, 'sameGarmentPartCount');

        this.idGarment = idGarment;
        this.idProduct = idProduct;
        this.name = name;
        this.descriptionShort = descriptionShort;
        this.description = description;
        this.link = link;
        this.image = image;
        this.price = price;
        this.priceTaxExcl = priceTaxExcl;
        this.priceLow = priceLow;
        this.priceLowPercentage = priceLowPercentage;
        this.priceLowAmount = priceLowAmount;
        this.garmentPartCount = garmentPartCount;
        this.sameGarmentPartCount = sameGarmentPartCount;
    }

    getIdGarment = (): number => this.idGarment;
    getIdProduct = (): number => this.idProduct;
    getName = (): string => this.name;
    getDescriptionShort = (): string => this.descriptionShort;
    getDescription = (): string => this.description;
    getLink = (): string => this.link;
    getImage = (): string => this.image;
    getPrice = (): string => this.price;
    getPriceTaxExcl = (): string => this.priceTaxExcl;
    getPriceLow = (): string => this.priceLow;
    getPriceLowPercentage = (): string => this.priceLowPercentage;
    getPriceLowAmount = (): string => this.priceLowAmount;
    getGarmentPartCount = (): number => this.garmentPartCount;
    getSameGarmentPartCount = (): number => this.sameGarmentPartCount;
}

export default Garment;
